module.exports = "/assets/54f87836b30d4fe559b9eb5702852e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/04.png
// module id = 1027
// module chunks = 0